import type { FC } from "react";
import { useMemo } from "react";

import signalEventsService from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalEventsService";
import type { IntentSignalDomainsEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

import IntentSignalEventTopics from "../IntentSignalEventTopics/IntentSignalEventTopics";
import IntentSignalDomainsEventTooltipBox from "../IntentSignalsEventsTooltipBox/IntentSignalDomainsEventTooltipBox";

type Props = {
    signal: IntentSignalDomainsEventDto;
};

const IntentSignalDomainsEventTopics: FC<Props> = ({ signal }) => {
    const topicItems = useMemo(() => {
        const topics = signalEventsService.getSignalEventsTopicsByDomains(signal);

        return topics.map(({ topic, domains }) => ({
            topic,
            tooltipContent: <IntentSignalDomainsEventTooltipBox domains={domains} />,
        }));
    }, [signal]);

    return <IntentSignalEventTopics topics={topicItems} />;
};

export default IntentSignalDomainsEventTopics;
